// Alpine.js

// import 'alpine-turbo-drive-adapter'
import Alpine from "alpinejs"
import * as qs from "qs"
import { xDataKit } from '../shared/browserKit'
import { main as alpineDirectivesMain } from './alpineDirectives'
window.Alpine = Alpine

document.addEventListener("DOMContentLoaded", ()=>{
  alpineDirectivesMain(Alpine)
  Alpine.magic('qs', () => qs)
  Alpine.magic('qss', () => qs.stringify)
  Alpine.magic('qsp', () => qs.parse)
  Alpine.magic('xd', () => xDataKit)
  Alpine.start()
});
